import { useQuery } from "@tanstack/react-query"
import { PredefinedResponsesActivityQuery } from "../lib/predefinedResponsesActivityQuery"

export function usePredefinedResponsesActivityQuery(
  ...args: Parameters<typeof PredefinedResponsesActivityQuery>
) {
  return useQuery(PredefinedResponsesActivityQuery(...args))
}
